import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

export const classes = {
  addCardButton: css`
    cursor: pointer;
    padding: ${spacing(2.5, 0, 2.5, 2.5)};
  `,
  buttonText: css`
    &:hover {
      font-weight: ${cssTheme.fonts.weights.medium};
    }
    button:disabled & {
      font-weight: normal;
    }
  `,
  plusIcon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: ${spacing(2)};
    padding: ${spacing(0)};
  `,
  disabledButtonWrap: css`
    padding-top: ${spacing(3)};
  `,
}
